<!-- The same shell every permit form uses: 800px, the breadcrumb back to /apply, the
     title and the card. Reused rather than restyled so this page cannot drift from the
     forms beside it - it was full-width before, because it wore the chooser's class. -->
<app-apply-shell
    permitLabel="Business Login"
    [showForm]="!sent"
    doneLink="/apply"
    doneLabel="Apply for a permit"
    outcome="A Business Login lets an organisation issue permits directly to its own staff, or to its clients and event guests. Tiwi Land Council approve each organisation and decide which permits it can issue."
>
    @if (!sent) {
        <!-- Before the form, because it is the thing most likely to send someone to the
         right page instead: almost everyone reaching this needs a permit, not a login. -->
        <p class="text-muted small mb-3">
            <strong>You don't need one to apply for a permit.</strong>
            If you just need access yourself, <a routerLink="/apply">apply for a permit</a> instead.
        </p>

        <ngxh6-form-embed
            [formName]="'business_login_application'"
            [options]="{ sticky_actions: false, reload_on_save: false, show_delete: false, show_archive: false }"
            (submitted)="onSubmitted($event)"
        ></ngxh6-form-embed>
    } @else {
        <div class="alert alert-success" role="alert">
            <h2 class="h5 mt-0">Application sent</h2>
            <p class="mb-2">Thank you - Tiwi Land Council will review your application and contact you.</p>
            <p class="mb-0">We've emailed a copy to the address you gave us.</p>
        </div>
        <p class="text-muted">
            A Business Login isn't needed to apply for a permit. If you need one before this is reviewed,
            <a routerLink="/apply">apply in the normal way</a>.
        </p>
    }
</app-apply-shell>
